import { Phone, Mail, MapPin } from "lucide-react";

const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_9ea2b88f-5c7d-4521-a088-49d68618abb6/artifacts/wocjce1q_Logo-Lackcenter-NEU.png";
const PHONE_NUMBER = "tel:+493916357115";
const EMAIL = "mailto:info@lackzentrum-wilke.com";
const GOOGLE_MAPS_LINK = "https://www.google.com/maps/dir//Silberbergweg+30,+39128+Magdeburg";

const footerLinks = [
  { label: "Home", href: "#home" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Galerie", href: "#galerie" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Kontakt", href: "#kontakt" },
];

const services = [
  "Fahrzeuglackierung",
  "Karosseriebau",
  "Unfallinstandsetzung",
  "Spot-Repair",
  "Kunststoffreparatur",
  "Glasreparatur",
  "Felgenaufbereitung"
];

const legalLinks = [
  { label: "Impressum", href: "/impressum" },
  { label: "Datenschutz", href: "/datenschutz" },
];

export const Footer = () => {
  const scrollToSection = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        const navbarHeight = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  };

  return (
    <footer className="bg-accent text-accent-foreground">
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src={COMPANY_LOGO}
              alt="Lack Zentrum Wilke Logo"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-accent-foreground/80 text-sm leading-relaxed mb-6">
              Ihr Lack- und Karosseriezentrum in Magdeburg. Professionelle 
              Fahrzeuglackierung und Unfallinstandsetzung seit 1988.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-accent-foreground/80 hover:text-primary-light transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">
              Leistungen
            </h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="text-accent-foreground/80 text-sm">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">
              Kontakt
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={GOOGLE_MAPS_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-accent-foreground/80 hover:text-primary-light transition-colors"
                >
                  <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">
                    Lack Zentrum Wilke GmbH<br />
                    Silberbergweg 30<br />
                    39128 Magdeburg
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={PHONE_NUMBER}
                  className="flex items-center gap-3 text-accent-foreground/80 hover:text-primary-light transition-colors"
                >
                  <Phone className="h-5 w-5 flex-shrink-0" />
                  <span className="text-sm">0391 635 771 15</span>
                </a>
              </li>
              <li>
                <a
                  href={EMAIL}
                  className="flex items-center gap-3 text-accent-foreground/80 hover:text-primary-light transition-colors"
                >
                  <Mail className="h-5 w-5 flex-shrink-0" />
                  <span className="text-sm">info@lackzentrum-wilke.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-accent-foreground/10">
        <div className="container mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-accent-foreground/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Lack Zentrum Wilke GmbH. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              {legalLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-accent-foreground/60 hover:text-primary-light text-sm transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
